import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CrypService } from 'src/app/services/Non-Master/Cryp.service';
import { tPatientService } from 'src/app/services/tPatient.service';
import { AppSettings } from 'src/app/shared/AppSettings';

@Component({
  selector: 'app-patient-sendOut-label',
  templateUrl: './patient-sendOut-label.component.html',
  styleUrls: ['./patient-sendOut-label.component.css']
})
export class PatientSendOutLabelComponent implements OnInit {
  @Input() patientID: string;

  patient = {
    patientID:"",
    name:"",
    surname:"",
    dob:"",
    hkid:"",
    hkidDesc:"",
    registeredDate:"",
    caseDrID:"",
    gender:"",
    age:""
  };

  constructor(
    public activeModal: NgbActiveModal,
    private patientService : tPatientService,
    private crypService: CrypService,
    private datePipe : DatePipe

  ) { }

  ngOnInit() {
    this.initPatientInfo();
  }

  initPatientInfo(){
    this.patientService.getLabelPrint(this.patientID,1).subscribe(x=>{
      this.patient = x.data;
      this.patient.hkid = this.crypService.decryptStr(this.patient.hkid).toString();

    })
  }

  getDateFomrat(value){
    if(!value) return "";
    return this.datePipe.transform(value,AppSettings.dateFormat);
  }

  getPrintDate(){
    return this.datePipe.transform(new Date(),AppSettings.dateFormat);
  }

}
